import Component from "@glimmer/component";
import { service } from "@ember/service";
import DButton from "discourse/ui-kit/d-button";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";

export default class PostMenuEditButton extends Component {
  static hidden(args) {
    if (args.state.isWikiMode || (args.post.can_edit && args.post.yours)) {
      return false;
    }

    // returning null here allows collapseByDefault to fallback to the value configured in the settings for the button
    return null;
  }

  static shouldRender(args) {
    return args.post.can_edit;
  }

  @service site;

  get showLabel() {
    return (
      this.args.showLabel ??
      (this.site.desktopView && this.args.state.isWikiMode)
    );
  }

  <template>
    <DButton
      class={{dConcatClass
        "post-action-menu__edit"
        "edit"
        (if @post.wiki "create")
      }}
      ...attributes
      @action={{@buttonActions.editPost}}
      @ariaLabel="post.controls.edit"
      @icon={{if @post.wiki "far-pen-to-square" "pencil"}}
      @label={{if this.showLabel "post.controls.edit_action"}}
      @title="post.controls.edit"
    />
  </template>
}
